import { CardFooterItem } from "$components/card";
import { FormattedDate } from "$components/date/formatted-date";
import { FormattedMessage } from "react-intl";

const UndispensedPrescriptionFooterItems: FC<{
  quantityToDispense?: number | null;
  validUntil: string;
}> = ({ quantityToDispense, validUntil }) => (
  <>
    {quantityToDispense != null && (
      <CardFooterItem
        label={
          <FormattedMessage
            id="patient.history.prescription.toDispenseTotal"
            defaultMessage="Total to dispense:"
          />
        }
      >
        {quantityToDispense}
      </CardFooterItem>
    )}
    <CardFooterItem
      label={
        <FormattedMessage
          id="patient.history.prescription.toDispenseBefore"
          defaultMessage="Valid to dispense until:"
        />
      }
    >
      <FormattedDate value={validUntil} />
    </CardFooterItem>
  </>
);

export { UndispensedPrescriptionFooterItems };
